const config = {
  rowSelection: false,
  search: false,
  pagination: false,
  scroll: {
    y: 'calc(100vh - 435px)',
  },
  columns: [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      render: 'orderIdRender',
      width: 180,
      fixed: 'left',
    },
    {
      title: '财务主体',
      dataIndex: 'companyConfigName',
      width: 230,
      ellipsis: true,
    },
    {
      title: '门店',
      dataIndex: 'companyOrgName',
      width: 120,
    },
    {
      title: '支付状态',
      dataIndex: 'payStatusName',
      width: 120,
      render: (text: string) => text || '-',
    },
    {
      title: '需求标签',
      dataIndex: 'bizTagName',
      width: 120,
      render: 'demandTagRender',
    },
    {
      title: '主合同号',
      dataIndex: 'contractNo',
      width: 180,
      render: (text: string) => text || '-',
    },
    {
      title: '订单状态',
      dataIndex: 'orderStatusName',
      width: 120,
      render: 'orderStatusRender',
    },
    {
      title: '订单/合同金额',
      dataIndex: 'orderAmount',
      width: 150,
      render: (text: string) => (text ? `¥ ${text}` : '-'),
    },
    {
      title: '应收金额',
      dataIndex: 'receivableAmount',
      width: 150,
      render: (text: string) => (text ? `¥ ${text}` : '-'),
    },
    {
      title: '应收余额',
      dataIndex: 'unReceiveAmount',
      width: 150,
      render: (text: string) => (text ? `¥ ${text}` : '-'),
    },
  ],
  footer: false,
}

export default config
